module.exports = {
      id: "pinterest-usage",
      viewBox: "0 0 44 44",
      url: __webpack_public_path__ + "svg-sprite-ef426a51ffa8e0d9106d678bb4289730.svg#pinterest",
      toString: function () {
        return this.url;
      }
    }